import { Container } from '@mui/material';
import AppBar from './AppBar';
import { AlertList, ConfirmationModal } from '../components';
import { Outlet } from 'react-router-dom';
import AuthRedirect from './AuthRedirect';

export default function Root() {
  return (
    <>
      <AlertList />
      <ConfirmationModal />
      <AppBar />
      <Container style={{ paddingTop: '20px', paddingBottom: '50px' }}>
        <AuthRedirect>
          <Outlet />
        </AuthRedirect>
      </Container>
    </>
  );
}